"use client";

import { usePopoverDescription } from "./FICKQG6J.js";
import { createElement, createHook, forwardRef } from "./7FZLUSKW.js";

// src/hovercard/hovercard-description.tsx
var TagName = "p";
var useHovercardDescription = createHook(function useHovercardDescription2(props) {
  props = usePopoverDescription(props);
  return props;
});
var HovercardDescription = forwardRef(function HovercardDescription2(props) {
  var htmlProps = useHovercardDescription(props);
  return createElement(TagName, htmlProps);
});
export { useHovercardDescription, HovercardDescription };